import { resourceQueryParamName } from 'constants/resourceQueryNames';
import useAgentSessions from 'hooks/agentSessions/useAgentSessions';
import { capitalize } from 'lodash';
import pluralize from 'pluralize';
import React from 'react';
import { useSelector } from 'react-redux';
import { getNavParamsByResource } from 'selectors/nav';

const AgentSessionsListCount: React.FC = () => {
  const { data, isLoading } = useAgentSessions();

  const navParams = useSelector(getNavParamsByResource(resourceQueryParamName.agentSessions));
  const offset = parseInt(navParams.offset as string, 10);

  if (!data) return null;

  return (
    <div>
      <div className={`${isLoading ? 'text-litlingo-gray-2' : ''}`}>
        <span className="font-bold">{` ${data.records.length === 0 ? 0 : offset + 1}-${
          offset + data.records.length
        }`}</span>
        {` of ${
          data && data.count >= 10000
            ? '+10,000'
            : pluralize('agent session'.split(' ').map(capitalize).join(' '), data.count, true)
        }`}
      </div>
    </div>
  );
};

export default AgentSessionsListCount;
